import { useFormContext } from 'react-hook-form';

import { LocationStoreType } from '@/features/listing/listing.types';

type PersistedLocationSearchReturnType = {
  getSearchedLocation: () => LocationStoreType | null;
};

export const usePersistedLocationSearch = (): PersistedLocationSearchReturnType => {
  const { getValues } = useFormContext();
  const getSearchedLocation = (): LocationStoreType | null => {
    const locationFieldZipCodeValue = getValues('zip');

    let location: LocationStoreType | null = null;
    if (typeof window === 'undefined') {
      return null;
    }

    const storedLocation = sessionStorage.getItem('selectedLocation')
      ? JSON.parse(sessionStorage.getItem('selectedLocation') || '')
      : null;
    if (storedLocation && storedLocation.zipCode === locationFieldZipCodeValue) {
      const { latitude, longitude, zipCode, address } = storedLocation;

      location = {
        address: (address as string) || '',
        zip: (zipCode as string) || '',
        latitude: parseFloat(latitude as string),
        longitude: parseFloat(longitude as string),
      };
    }
    return location;
  };

  return {
    getSearchedLocation,
  };
};
